
import { useScenario } from "../../contexts/ScenarioContext"

import CheckBoxIcon from "../icons/CheckBoxIcon"

const FormCheckBox = ({ id, label, abbrLabel, clickHandler }) => {
    const { isChecked } = useScenario()
    const getLabel = () => !!abbrLabel ? abbrLabel : label
    return (
        <span onClick={clickHandler}>
            <CheckBoxIcon checked={isChecked(id)} />
            <span>
                {getLabel()}
            </span>
        </span>
    )
}

export default FormCheckBox